import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ValidatorFn, Validators } from '@angular/forms';
import { BaseFieldComponent } from '../base-field/base-field.component';
import { AppModule } from '../../../../modules/app.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { ThirdPartyModule } from '../../../../modules/third-party.module';
import { AngularModule } from '../../../../modules/angular.module';
import { InputControlComponent } from '../../../controls/standard/input-control/input-control.component';

@Component({
	selector: 'app-text-field',
	standalone: true,
	imports: [AppModule, ZorroModule, ThirdPartyModule, AngularModule, InputControlComponent],
	templateUrl: './text-field.component.html',
	styleUrls: ['./text-field.component.scss'],
})
export class TextFieldComponent extends BaseFieldComponent {
	@Input('enableUpload') public enableUpload: boolean = false;
	@Input('accept') public accept: string = '';
	@Input('multiple') public multiple: boolean = false;
	@Input('directory') public directory: boolean = false;
	@Input('mimeType') public mimeType: string = '';
	@Input('enablePrevious') public enablePrevious: boolean = false;
	@Input('autocomplete') public autocomplete: string = 'on';
	@Input('disabled') public disabled: boolean = false;
	@Output('showPrevious') public showPrevious: EventEmitter<void> = new EventEmitter<void>();

	public static override validators: ValidatorFn[] = [Validators.required];
}
